import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { MessageService } from 'primeng/api';
import { catchError, throwError } from 'rxjs';
import { HANDLES_OWN_ERRORS } from './error-context';
import { apiErrorReason, translatorOf } from './error-reason';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const messageService = inject(MessageService);
  const translocoService = inject(TranslocoService);

  return next(req).pipe(
    catchError((err: HttpErrorResponse) => {
      if (err.status === 401) {
        // Auth interceptor handles 401 — do not show a toast
        return throwError(() => err);
      }

      if (req.context.get(HANDLES_OWN_ERRORS)) {
        // Екранът казва причината сам — втори, общ тостер само дублира (#403).
        return throwError(() => err);
      }

      messageService.add({
        severity: 'error',
        summary: translocoService.translate('error.title'),
        detail: apiErrorReason(err, translatorOf(translocoService)),
        life: 6000,
      });

      return throwError(() => err);
    })
  );
};
